import { QuestionBase } from './question-base';

export class CurrencyQuestion extends QuestionBase<number> {
  controlType = 'currency';
}
